import { useState, ChangeEvent } from 'react';
import { AddOrderHistory } from '../../../../store/entities/orders/type';
import Dialog from '../../../../components/UI/Dialog/Dialog';
import TextInput from '../../../../components/UI/TextInput/TextInput';
import useTranslations from '../../../../hooks/useTranslations';

import './AddOrderHistory.scss';
import { OrdersActions } from '../../../../store/entities/orders/orders.actions';
import { useDispatch } from 'react-redux';

interface Iprops {
  showDialog: Function;
  orderId: string;
}

const AddOrderHistoryDialog = (props: Iprops) => {
  const { rcTranslate } = useTranslations();
  const dispatch = useDispatch();
  const [orderHistoryMessage, setOrderHistoryMessage] = useState<string>('');
  const maxMessageLength = 256;

  const handleMessageChange = (message: string) => {
    if (message.length <= maxMessageLength) setOrderHistoryMessage(message);
  };

  const addOrderHistoryBody = () => {
    return (
      <div className="addOrderHistoryBody">
        <TextInput
          id={'addOrderHistory'}
          label={rcTranslate('orders.orderHistory.addNewRecord.textInputLabel')}
          multiline={true}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            handleMessageChange(e.target.value)
          }
          onBlur={(e: any) => {
            handleMessageChange(e.target.value);
          }}
          value={orderHistoryMessage}
          autoFocus={false}
          className={'addOrderHistory'}
        />
        <div>
          <p className="pHelper characters">{`${orderHistoryMessage.length}/${maxMessageLength} ${rcTranslate('orders.orderHistory.addNewRecord.characters')}`}</p>
        </div>
        {orderHistoryMessage.length === maxMessageLength ? (
          <p className="orderHistoryMessageValidationText pHelper">
            {rcTranslate('orders.orderHistory.addNewRecord.lengthLimit')}
          </p>
        ) : null}
      </div>
    );
  };

  const handleAddOrderHistory = async () => {
    const data: AddOrderHistory = {
      notes: orderHistoryMessage,
      orderId: parseInt(props.orderId),
    };
    await dispatch(OrdersActions.addOrderHistory(data));
    props.showDialog(false);
  };

  return (
    <Dialog
      className="addOrderHistory_dialog"
      title={rcTranslate('orders.orderHistory.addNewRecord.title')}
      body={addOrderHistoryBody()}
      confirmTitle={'button.send'}
      disabled={!orderHistoryMessage}
      onConfirm={handleAddOrderHistory}
      onClose={() => {
        props.showDialog(false);
      }}
    />
  );
};

export default AddOrderHistoryDialog;
